import React from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFile, faSquare } from "@fortawesome/free-solid-svg-icons";

import RectangleFieldOptions from './options/RectangleFieldOptions'
import RectangleTableOptions from './options/RectangleTableOptions'
import StaticValueFieldOptions from './options/StaticValueFieldOptions'
import TextSearchFieldOptions from './options/TextSearchFieldOptions'
import SearchBasedTableOptions from './options/SearchBasedTableOptions'
import GridCellFieldOptions from './options/GridCellFieldOptions'

import classNames from 'classnames'
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export default class ObjectOptions extends React.Component {

  // checks if the source object is a rectangle table (NOT search based table)
  // see "private bool IsVisibleTable(TemplateObject templateObject)" in C# desktop template editor 
  // that was used as as base
  isVisibleTable = (object) => {
    const props = object["tableProperties"]

    try{
    const convertedProps = typeof props === 'string' ? JSON.parse(props) : props;

    //console.log(`Searchbased table parsed OK: ${props}`);

/* // from c# code
return props != null && 
props.Start != null && 
props.End != null &&
           !float.IsNaN(props.Start.Y) &&
            props.Start.PageIndex != -1 &&
           !float.IsNaN(props.End.Y) && 
           props.End.PageIndex != -1 &&
           props.Start.PageIndex == props.End.PageIndex &&
           !float.IsNaN(props.Left) && !float.IsNaN(props.Right);
*/    
    
    return props && 
      convertedProps["start"] && 
      convertedProps["end"] &&
      !isNaN(convertedProps["start"]["y"]) &&
      convertedProps["start"]["pageIndex"] !== -1 &&
      !isNaN(convertedProps["end"]["y"]) &&
      convertedProps["end"]["pageIndex"] !== -1 &&
      convertedProps["start"]["pageIndex"] === convertedProps["end"]["pageIndex"] &&
      !isNaN(convertedProps["left"]) && 
      !isNaN(convertedProps["right"])
    }
    catch(e){
      //setError(`Error parsing template code: ${e}`);
      console.log(`Error parsing template object code: ${e}`);
      //console.log(`Template code: ${props}`);

    }
  }

  handleRunTestObject = (objectId, objectType) => {
    if (this.props.isCustomFile) {
      this.props.runTemplateWithOneObject(objectId, objectType)
    }
    else {
      if (window.confirm("No PDF file is loaded for testing. Do you want to load PDF file now?")) {
        this.props.handleUploadPdf()
      }
    }
  }

  renderTooltip = (name, id, props) => (
    <Tooltip id={id} {...props} className="tooltip-btn">
      {name}
    </Tooltip>
  );

  render() {
    var optionsComponent = null
    const object = this.props.object
    const objects = this.props.objects
    const buttonsClasses = classNames("btn btn-outline-secondary pull-right mL-10", { hidden: !object })
    const buttonsClassesDanger = classNames("btn btn-danger pull-right mL-10", { hidden: !object })
    const buttonsClassesWarning = classNames("btn btn-warning pull-right mL-10", { hidden: !object })

    const runTemplateResult = this.props.runTemplateResult.jsonResult && JSON.parse(this.props.runTemplateResult.jsonResult.replace(/(\r\n|\n|\r)/gm, ""))
    const showTestResult = object && object["objectType"] == "field" && runTemplateResult && runTemplateResult.objects && this.props.testFieldResultId == object.id
    if (object) {
      if (object["objectType"] == "field" && object["fieldProperties"]["fieldType"] == "rectangle") {
        optionsComponent = <RectangleFieldOptions {...this.props} />
      } else if (object["objectType"] == "field" && object["fieldProperties"]["fieldType"] == "static") {
        optionsComponent = <StaticValueFieldOptions {...this.props} />
      } else if (object["objectType"] == "field" && object["fieldProperties"]["fieldType"] == "macros") {
        optionsComponent = <TextSearchFieldOptions {...this.props} />
      } else if (object["objectType"] == "table" && !this.isVisibleTable(object)) {
        try{
          optionsComponent = <SearchBasedTableOptions {...this.props} />
        }
        catch(e){
          optionsComponent = undefined;
          console.log(`ObjectOptions error SearchBasedTableptions: ${e}`);
          alert(`ObjectOptions error SearchBasedTableptions: ${e}`);          
        }
      } else if (object["objectType"] == "table" && this.isVisibleTable(object)) {
        optionsComponent = <RectangleTableOptions {...this.props} />
      } else if (object["objectType"] == "field" && object["fieldProperties"]["fieldType"] == "structure") {
        optionsComponent = <GridCellFieldOptions {...this.props} />
      } else {
        // Default Object Properties
        optionsComponent = <TextSearchFieldOptions {...this.props} />
      }
    }



    return (
      <div className="object-options ta-left mt-2">
        <h6>Selected Object Properties:</h6>

{/*
        {!this.props.isCustomFile && !this.props.isTemplateModified && (
          <OverlayTrigger placement="bottom"
                          delay={{ show: 250, hide: 400 }}
                          overlay={(props) => this.renderTooltip("Create or Open Template from templates library", "template_library_id", props)}>
            <button disabled={this.props.isRunningTemplate} className="btn btn-success db-create-template-big-button mT-10" data-toggle="tooltip" data-placement="bottom" onClick={this.props.handleOpenSampleTemplate}>
              <FontAwesomeIcon icon={faFile} /> Create or Open Template
            </button>
          </OverlayTrigger>
        )}
*/}        

        {optionsComponent}
        <div className="row">
          <div className="col-lg-12 mB-10">
            <button disabled={this.props.isRunningTemplate} className={buttonsClassesWarning} onClick={e => this.handleRunTestObject(object.id, object.objectType)}>{this.props.isRunningTemplate ? 'Testing...' : 'Test Object'}</button>
          </div>
        </div>
        {
          showTestResult &&
          <textarea disabled rows="10" id="objectTestResult" className="form-control mB-10 bg-warning" value={runTemplateResult.objects[0].value}></textarea>
        }
      </div>
    );
  }
}
